import { filterItemsBasedOnUserPermissions } from 'src/misc/Session';
import { LuUsers2, LuShieldCheck, LuBuilding } from 'react-icons/lu';
import { AiOutlineRobot } from 'react-icons/ai';
import { BsRobot } from 'react-icons/bs';
import ReactDOMServer from 'react-dom/server';
import { scrubHtml } from 'src/misc/Misc';

export const getAdminItems = (userPermissions, homePageFilter) => [
  {
    group: 'People and permissions',
    items: [
      { id: 'tenants', title: 'Tenants', icon: <LuBuilding />, permissions: ['admin.master'], path: '/master-admin/tenants', imageBgColor: 'rgb(234 88 12)', imageBgColorDark: 'rgb(251 146 60)' },
      { id: 'users', title: 'Users', icon: <LuUsers2 />, permissions: ['admin.master'], path: '/master-admin/users', imageBgColor: 'rgb(101 163 13)', imageBgColorDark: 'rgb(163 230 53)' },
      {
        id: 'permissions',
        title: (
          <>
            Roles & <br />
            Permissions
          </>
        ),
        icon: <LuShieldCheck />,
        permissions: ['admin.master'],
        path: '/master-admin/roles-permissions',
        imageBgColor: 'rgb(8 145 178)',
        imageBgColorDark: 'rgb(34 211 238)',
      },
    ]
      .filter((item) => filterItemsBasedOnUserPermissions(item, userPermissions))
      .filter((item) => !homePageFilter?.length > 0 || scrubHtml(ReactDOMServer.renderToString(item.title))?.toLowerCase().includes(homePageFilter?.toLowerCase())),
  },
  {
    group: 'Artificial intelligence',
    items: [
      { id: 'aiModels', title: 'AI Models', icon: <AiOutlineRobot />, permissions: ['admin.master'], path: '/master-admin/aimodels', imageBgColor: 'rgb(192 38 211)', imageBgColorDark: 'rgb(232 121 249)' },
      { id: 'copilot', title: 'Copilot', icon: <BsRobot />, permissions: ['admin.master'], path: '/master-admin/copilot', imageBgColor: 'rgb(255 79 31)', imageBgColorDark: 'rgb(255 79 31)' },
    ]
      .filter((item) => filterItemsBasedOnUserPermissions(item, userPermissions))
      .filter((item) => !homePageFilter?.length > 0 || scrubHtml(ReactDOMServer.renderToString(item.title))?.toLowerCase().includes(homePageFilter?.toLowerCase())),
  },
];
